const Ready = (callback) => {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', () => callback(), {
      once: true,
    });
  }
};

export async function waitUntil(condition, timer = 500): Promise<void> {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (condition) {
        resolve();
        clearInterval(interval);
      }
    }, timer);
  });
}

export default Ready;
